<template>
  <el-dialog
    title="重置设置"
    :visible="visible"
    width="800px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <div v-if="form.username" class="user-meta">
      <span>用户: {{ form.username }}</span>
      <span class="meta-gap">接入号: {{ form.mch_id }}</span>
    </div>
    <el-table :data="detailTable" border :show-header="false">
      <el-table-column prop="label" width="140">
        <template slot-scope="scope">{{ scope.row.label }}</template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <span v-if="scope.row.key === 'mch_key'">{{ maskKey(form.mch_key) }}</span>
          <span v-else-if="scope.row.key === 'username'">{{ form.username }}</span>
          <span v-else-if="scope.row.key === 'mch_id'">{{ form.mch_id }}</span>
          <span v-else>******</span>
        </template>
      </el-table-column>
      <el-table-column width="180" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.copyable"
            size="small"
            type="success"
            class="ele-btn-icon"
            @click="copyValue(scope.row.key)">
            复制
          </el-button>
          <el-button
            v-if="scope.row.resetType"
            size="small"
            :type="scope.row.buttonType"
            class="ele-btn-icon"
            :loading="loadingMap[scope.row.resetType]"
            @click="resetField(scope.row.resetType)">
            {{ loadingMap[scope.row.resetType] ? '重置中...' : '重置' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="updateVisible(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
const RESET_API = {
  key: '/user/resetKey',
  login: '/user/resetPwd',
  withdraw: '/user/resetCzPwd'
};

const CONFIRM_MSG = {
  key: '确定要重置密钥吗？',
  login: '确定要重置登录密码吗？',
  withdraw: '确定要重置取款密码吗？'
};

export default {
  name: 'DetailEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: Object.assign({}, this.data || {}),
      loadingMap: {
        key: false,
        login: false,
        withdraw: false
      },
      detailTable: [
        { label: '商户名称:', key: 'username', copyable: true },
        { label: '商户编号:', key: 'mch_id', copyable: true },
        { label: '商户密钥:', key: 'mch_key', copyable: true, resetType: 'key', buttonType: 'primary' },
        { label: '登录密码:', key: 'login_pwd', resetType: 'login', buttonType: 'warning' },
        { label: '取款密码:', key: 'withdraw_pwd', resetType: 'withdraw', buttonType: 'danger' }
      ]
    };
  },
  watch: {
    data: {
      deep: true,
      handler(val) {
        this.form = Object.assign({}, val || {});
      }
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    maskKey(value) {
      const text = String(value || '');
      if (!text) return '';
      if (text.length <= 8) return text.slice(0, 2) + '****' + text.slice(-2);
      return text.slice(0, 4) + '****' + text.slice(-4);
    },
    copyValue(key) {
      const text = this.form[key];
      if (!text) {
        this.$message.warning('暂无可复制内容');
        return;
      }
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('已复制');
    },
    resetField(type) {
      const url = RESET_API[type];
      if (!url) return;
      this.$confirm(CONFIRM_MSG[type], '提示', { type: 'warning' })
        .then(() => {
          this.$set(this.loadingMap, type, true);
          this.$http
            .post(url, { id: this.form.id })
            .then((res) => {
              if (type === 'key' && res.data.data && res.data.data.new_key) {
                this.form.mch_key = res.data.data.new_key;
              }
              if (res.data.code === 0) {
                this.$message.success(res.data.msg || '重置成功');
                this.$emit('done');
              } else {
                this.$message.error(res.data.msg || '重置失败');
              }
            })
            .catch((e) => {
              this.$message.error('请求失败：' + e.message);
            })
            .finally(() => {
              this.$set(this.loadingMap, type, false);
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.user-meta {
  margin-bottom: 20px;
}
.meta-gap {
  margin-left: 20px;
}
</style>
